import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { LabProvider } from './context/LabContext';
import './styles/index.css';

// LabProvider is kept for backward compatibility with existing experiment components
// New components use AppContext, ExperimentContext, ProgressContext from App.tsx
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LabProvider>
      <App />
    </LabProvider>
  </React.StrictMode>,
);
